module.exports = __webpack_public_path__ + "img/73.15b33815.png";